import getCharacterArmourDexPen from '../helpers/getCharacterArmourDexPen'

//--------------------------------------------------------------------------------------------------------------
// process remove equipped armour (remove armour from armour_location/equipped armour arrays for frontend only)
//--------------------------------------------------------------------------------------------------------------
export default function processRemoveEquippedArmour({ armour_id = null, character = null }) {
  console.log('----------------------------------------------')
  console.log('IN processRemoveEquippedArmour parms = ', { armour_id, character })
  /*
    - armour_id = id of equipped armour to be removed
    - character = character object
  */
  //-------------
  // check parms
  //-------------
  if (!armour_id || !character) {
    console.error('*** processRemoveEquippedArmour - Missing parms:', {
      armour_id,
      character,
    })
    return
  }
  //-------------------------------------------------------------------------------------------------
  // should be armour locations even if no equipped armour (or is new character - albeit ids = temp)
  //-------------------------------------------------------------------------------------------------
  if (!character.armour_locations || !Array.isArray(character.armour_locations)) {
    console.error('*** processRemoveEquippedArmour - Invalid armour_locations:', {
      armour_locations: character.armour_locations,
    })
    return
  }

  console.log(
    'processRemoveEquippedArmour current character armour_locations = ',
    character.armour_locations,
  )

  //=====================================================================================
  // INTERNAL FUNCTION - recalc aggregates at character armour location level
  // (mirrors backend CharacterArmourLocation.get_dex_pen_percent/get_highest_ap and
  // adds highest_layer as max equipped layer)
  //----------------------------------------------------------------------------------
  function _updateLocationAggregates(character_armour_location) {
    if (!character_armour_location) return

    const equipped = Array.isArray(character_armour_location.equipped_armour)
      ? character_armour_location.equipped_armour
      : []

    // armour_count: only entries with a non-null armour id
    const armour_count = equipped.filter((ea) => ea && ea.armour != null).length

    let highest_ap = 0
    let highest_layer = 0
    let dex_pen = 0

    equipped.forEach((ea) => {
      if (!ea) return

      const ap = Number(ea.ap) || 0
      if (ap > highest_ap) highest_ap = ap

      const layer = Number(ea.layer)
      if (!Number.isNaN(layer) && layer > highest_layer) {
        highest_layer = layer
      }

      const dp = Number(ea.dex_pen) || 0
      dex_pen += dp
    })

    character_armour_location.armour_count = armour_count
    character_armour_location.highest_ap = highest_ap
    character_armour_location.highest_layer = highest_layer
    character_armour_location.dex_pen = dex_pen
  }

  //=====================================================================================
  // INTERNAL FUNCTION - recalc overall character dex_pen_percent_armour
  // (mirrors backend get_dex_pen_percent_armour: sum of dex_pen_percent
  // over all CharacterLocationEquippedArmour entries via per-location totals)
  //---------------------------------------------------------------------------
  function _updateCharacterDexPenArmour(character) {
    if (!character) return
    character.dex_pen_percent_armour = getCharacterArmourDexPen(character)
  }

  // get equipped armour item object
  const armour_obj = character.items.find((item) => item.id === armour_id)

  if (!armour_obj) {
    console.error(
      '*** processRemoveEquippedArmour - Unable to find equipped armour item with id:',
      armour_id,
    )
    return
  }

  // Determine whether this is non-fixed coverage (armour_location set on item)
  const isNonFixed = !!armour_obj.armour_location

  if (isNonFixed && armour_obj.armour_location_name) {
    //---------------------------------------------------------------------------
    // (b) NON-FIXED LOCATION ARMOUR
    // First narrow to the specific armour_location_name on the item (e.g. Lower Left Leg)
    // to avoid removing the wrong piece when multiple items share the same name.
    //---------------------------------------------------------------------------
    character.armour_locations.forEach((loc) => {
      if (!loc || loc.armour_location_name !== armour_obj.armour_location_name) return

      if (!Array.isArray(loc.equipped_armour)) return

      const beforeLen = loc.equipped_armour.length

      // Remove any equipped_armour entries for this specific character item
      // at this location (match by character-item id, not name).
      loc.equipped_armour = loc.equipped_armour.filter((ea) => !(ea && ea.armour === armour_obj.id))

      if (loc.equipped_armour.length !== beforeLen) {
        _updateLocationAggregates(loc)
      }
    })

    // Clear the item's selected armour location so that flexible armour
    // no longer shows as being assigned to this location once unequipped.
    armour_obj.armour_location = null
    armour_obj.armour_location_name = null
  } else {
    //---------------------------------------------------------------------------
    // (a) FIXED LOCATION ARMOUR
    // No specific armour_location on the item; this armour may appear on
    // multiple locations via fixed coverage. Remove all equipped_armour entries
    // whose armour_name matches this item name across all locations.
    //---------------------------------------------------------------------------
    character.armour_locations.forEach((loc) => {
      if (!loc || !Array.isArray(loc.equipped_armour)) return

      const beforeLen = loc.equipped_armour.length

      // For fixed coverage, this item may appear on multiple locations, but
      // each equipped_armour entry still references the same character-item
      // id. Remove only entries whose armour id matches this item.
      loc.equipped_armour = loc.equipped_armour.filter((ea) => !(ea && ea.armour === armour_obj.id))

      if (loc.equipped_armour.length !== beforeLen) {
        _updateLocationAggregates(loc)
      }
    })
  }

  // Recalculate character-level armour dex penalty percent
  _updateCharacterDexPenArmour(character)

  console.log('END processRemoveEquippedArmour')
  return character
}
